import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downhole',
  templateUrl: './downhole.component.html',
  styleUrls: ['./downhole.component.css']
})
export class DownholeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
